import { useCallback, useState } from 'react'
import { useClickOutside } from '@mailstep/design-system/ui/Blocks/Modal/hooks/useClickOutside'
import { useThemeMode } from '@contexts/ThemeModeContext/hooks/useThemeMode'
import { ThemeMode } from '@contexts/ThemeModeContext/ThemeModeContext'

export const useThemeModeToggle = () => {
  const { themeMode, setThemeMode } = useThemeMode()
  const [showDropdown, setShowDropdown] = useState(false)

  const onClose = useCallback(() => {
    setShowDropdown(false)
  }, [])

  const ref = useClickOutside({ onClose })

  const toggleDropdown = useCallback(() => {
    setShowDropdown((prev) => !prev)
  }, [])

  const handleSelect = useCallback(
    (mode: ThemeMode) => () => {
      setThemeMode(mode)
      setShowDropdown(false)
    },
    [setThemeMode],
  )

  return { themeMode, showDropdown, ref, toggleDropdown, handleSelect }
}
